<template>
  <div class="container">
    <Table
      type="advanced"
      :perPage="false"
      :sortable="false"
      class="chat"
    >
      <thead>
        <tr>
          <th>Time</th>
          <th>Channel</th>
          <th class="text-left">Player</th>
          <th class="text-left">Message</th>
        </tr>
      </thead>

      <tbody>
        <template
          v-for="(chat, key) in replay.data.chatlog"
        >
          <tr
            v-if="key > 0 && chat.time - replay.data.chatlog [key - 1].time > 60"
            class="separator"
          >
            <td colspan="4"></td>
          </tr>

          <tr
            :style="`background-color: ${rgba ('--wc3-' + player (chat.playerId).colour, 0.1)}`"
            class="chat-row"
          >
            <td>
              {{ time (chat.time) }}

              <!-- <Bar :fill="chat.time / maxTime * 100"></Bar> -->
            </td>
            <td>{{ lang (`channel.${chat.mode}`) || 'Private' }}</td>
            <td
              class="text-left"
              :style="`color: ${rgba ('--wc3-' + player (chat.playerId).colour)}`"
            >
              {{ battleTag (player (chat.playerId).name) }}
            </td>
            <td class="text-left">{{ chat.message }}</td>
          </tr>
        </template>
      </tbody>
    </Table>
  </div>
</template>

<script>
  import Table from '@/legacy/components/widgets/Table.vue';
  import Bar from '@/legacy/components/widgets/Bar';
  import { time } from '@/legacy/lib//util';
  import { lang } from '@/legacy/lib//lang';
  import { rgba, metaFactory, battleTag } from '@/legacy/lib//template';

  export default {
    metaInfo () {
      return metaFactory ({
        title: `${this.replay.name} Chatlog`,
        description: `In-game chatlog for ${this.replay.name}.`
      });
    },

    components: {
      Table,
      Bar
    },

    methods: {
      time,
      rgba,
      lang,
      battleTag,

      player: function (playerId) {
        for (let player of this.replay.data.game.players) {
          if (player.id != playerId) {
            continue;
          }

          return player;
        }

        return null;
      }
    },

    props: {
      replay: {
        type: Object
      }
    },

    computed: {
      maxTime: function () {
        return this.replay.data.chatlog [this.replay.data.chatlog.length - 1].time;
      }
    }
  };
</script>